import { Hero } from '@/components/Hero'
import { getProjectsData, ProjectsList } from '@/components/ProjectsList'
import Search from '@/components/Search'
import { laravelGraphqlEndpoint } from '@/globals/globals'
import { CarMake, CarModel } from '@/types/car'
import { Project } from '@/types/project'
import { Button, Flex } from '@chakra-ui/react'
import { gql, request } from 'graphql-request'

export async function getStaticProps() {
  let projects = await getProjectsData({ page: 1 })

  let carData = await request(
    laravelGraphqlEndpoint,
    gql`
      {
        carMakes {
          name
          id_car_make
        }
        carModels {
          name
          id_car_model
        }
      }
    `
  )

  return {
    props: {
      projects,
      carMakes: carData.carMakes,
      carModels: carData.carModels,
    },
    revalidate: 5,
  }
}

type Props = {
  projects: Project[]
  carMakes: CarMake[]
  carModels: CarModel[]
}

export default function Nation(props: Props) {
  return (
    <>
      <Hero heading='Featured Projects'>
        <Flex p={8} gridGap={4} align='center' justify='center'>
          <Button
            as='a'
            href='/nation/categories'
            backgroundColor='white'
            color='blue.400'
            borderRadius='full'>
            Categories
          </Button>
          <Search />
        </Flex>
      </Hero>
      <ProjectsList projects={props.projects} />
    </>
  )
}
